<template>
  <div class="bg-white shadow-md animate-pulse"></div>
</template>

<script>
export default {}
</script>

<style></style>
